import { Base } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class GalleryBtn extends Base {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'GalleryBtn',
    emits: ['gallery-open'],
  };

  /**
   * On btn click
   * @returns {void}
   */
  onClick() {
    this.$emit('gallery-open');
  }
}
